<template>
  <div
    class="lang-select-container j-card-select-container"
    @mouseleave="hideLangSelecter"
    @click.stop
  >
    <div
      class="lang-item j-select-lang-item"
      :pointValue="langVal"
      :class="{ active: langVal == curLang }"
      @click="selectLang(langVal)"
      v-for="(text, langVal) in langList"
      :key="langVal"
    >
      {{ text }}
    </div>
    <div class="sanjiao"></div>
  </div>
</template>
<script>
export default {
  name: 'LangSelecter',
  props: ['langList', 'curLang'],
  methods: {
    selectLang(langVal) {
      this.$emit('selectLang', langVal);
    },
    hideLangSelecter() {
      this.$emit('hideLangSelecter');
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@assets/scss/officialWebStore/_dimen.scss';
.lang-select-container {
  position: absolute;
  top: 106px;
  left: 50%;
  transform: translateX(-50%);
  display: grid;
  /*  声明列的宽度  */
  grid-template-columns: repeat(3, 196px);
  /*  声明行间距和列间距  */
  grid-row-gap: 26px;
  grid-column-gap: 18px;
  /*  声明行的高度  */
  grid-template-rows: 55px;
  width: 710px;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0px 10px 10px 0px rgba(231, 231, 231, 0.4);
  z-index: 1001;
  padding: 40px;
  .lang-item {
    display: inline-block;
    width: 196px;
    height: 55px;
    line-height: 55px;
    font-size: 24px;
    color: #333;
    text-align: center;
    @include g-border(1px);
    border-radius: 30px;
    cursor: pointer;
    // margin-bottom: 26px;
    &:hover {
      color: $btnBg;
    }
    &.active {
      color: $btnBg;
    }
  }
}
@media screen and (orientation: landscape) {
  .lang-select-container {
    width: 378px;
    left: unset;
    transform: unset !important;
    right: 0;
    top: 66px;
    /*  声明列的宽度  */
    grid-template-columns: repeat(2, 160px);
    /*  声明行间距和列间距  */
    grid-row-gap: 10px;
    grid-column-gap: 20px;
    /*  声明行的高度  */
    grid-template-rows: 44px;
    padding: 20px;
    .lang-item {
      width: 159px;
      height: 44px;
      line-height: 44px;
      font-size: 16px;
    }
    .sanjiao {
      position: absolute;
      top: -43px;
      right: 38px;
      width: 0;
      height: 0;
      border: 26px solid transparent;
      border-bottom: 26px solid #fff;
    }
  }
}
</style>

